export type MimeTypes =
  | 'application/pdf'
  | 'application/epub+zip'
  | 'image/jpeg'
  | 'image/png'
  | 'image/gif'
  | 'video/mp4'
  | 'video/webm'
  | 'audio/mpeg'
  | 'audio/wav'
  | 'audio/mp4'
  | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  | 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  | 'url'; // Added for website type

export const mimeTypeConfigsByType = {
  book: [
    { mimeType: 'application/pdf' as MimeTypes, extension: 'pdf' },
    { mimeType: 'application/epub+zip' as MimeTypes, extension: 'epub' },
  ],
  document: [
    {
      mimeType:
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' as MimeTypes,
      extension: 'docx',
    },
    {
      mimeType:
        'application/vnd.openxmlformats-officedocument.presentationml.presentation' as MimeTypes,
      extension: 'pptx',
    },
    {
      mimeType:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' as MimeTypes,
      extension: 'xlsx',
    },
  ],
  website: [{ mimeType: 'url' as MimeTypes, extension: 'url' }],
  audio: [
    { mimeType: 'audio/mpeg' as MimeTypes, extension: 'mp3' },
    { mimeType: 'audio/wav' as MimeTypes, extension: 'wav' },
    { mimeType: 'audio/x-m4a' as MimeTypes, extension: 'm4a' },
  ],
  video: [
    { mimeType: 'video/mp4' as MimeTypes, extension: 'mp4' },
    { mimeType: 'video/webm' as MimeTypes, extension: 'webm' },
  ],
  image: [
    { mimeType: 'image/jpeg' as MimeTypes, extension: 'jpg' },
    { mimeType: 'image/png' as MimeTypes, extension: 'png' },
    { mimeType: 'image/gif' as MimeTypes, extension: 'gif' },
  ],
} as const;

// Flatten configs for the mapping objects
const allMimeTypeConfigs = Object.values(mimeTypeConfigsByType).flat();

export const mimeTypeToExtension: Record<MimeTypes, string> =
  Object.fromEntries(
    allMimeTypeConfigs.map(({ mimeType, extension }) => [mimeType, extension])
  ) as Record<MimeTypes, string>;

export const extensionToMimeType: Record<string, MimeTypes> =
  Object.fromEntries(
    allMimeTypeConfigs.flatMap(({ mimeType, extension }) => [
      [extension, mimeType],
      // Special case for jpeg
      ...(extension === 'jpg' ? [['jpeg', mimeType]] : []),
    ])
  ) as Record<string, MimeTypes>;
